import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { FavouriteStation } from '../../types';

export const getFavouriteStations = createReduxAsyncThunk<{ favouriteStations: FavouriteStation[] }>(
  `${STATIONS_STATE}/getFavouriteStations`,
  async () => {
    const { data } = await stationsAPI.getFavouriteStations();
    return data;
  }
);
